import { render } from "./WhyGrid.vue?vue&type=template&id=af7abfd6&scoped=true"
import script from "./WhyGrid.vue?vue&type=script&lang=js"
export * from "./WhyGrid.vue?vue&type=script&lang=js"

import "./WhyGrid.vue?vue&type=style&index=0&id=af7abfd6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af7abfd6"]])

export default __exports__